import {ServiceRequest} from './../Models/ServiceRequest';
import {Injectable} from '@angular/core';
import {Helper} from '../../helpers/helper.service';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {BehaviorSubject} from 'rxjs';
import {MenuItems} from '../../shared/menu-items/menu-items';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ServiceRequestService {
  public serviceRequest: BehaviorSubject<ServiceRequest> = new BehaviorSubject<ServiceRequest>(new ServiceRequest());

  constructor(
    private helper: Helper,
    private http: HttpClient,
    private menuItems: MenuItems
  ) {
  }

  public getServiceRequests(gridData = new HttpParams()) {
    this.fetchNotificationsCount();
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-request/?' + gridData.toString())
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getServiceRequestItem(id = null) {
    return this.http.get<ServiceRequest>(environment.apiUrl + '/backoffice/service-request/' + id)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getServiceRequestStatuses() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-request/statuses')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getSolutions(serviceSubjectId) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-request/solutions/' + serviceSubjectId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getServiceSubjects() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-request/service-subjects/')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public fetchServiceRequestComplete(requestId, complete = true) {
    if (complete) {
      this.serviceRequest.next(new ServiceRequest());
    }

    return this.http.get<ServiceRequest>(
      environment.apiUrl + '/backoffice/service-request/' + requestId
    ).pipe(catchError(res => this.helper.catchError(res))).subscribe((res: ServiceRequest) => {
      this.fetchNotificationsCount();
      this.serviceRequest.next(res);
    });
  }

  public selectSolution(requestId, solutionId) {
    return this.http.post<any>(environment.apiUrl + '/backoffice/service-request/select-solution', {
        serviceRequest: requestId,
        solution: solutionId
      })
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public cancelSolution(requestId) {
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-request/cancel-solution/' + requestId)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public confirmStep(data) {
    return this.http.post<any>(environment.apiUrl + '/backoffice/service-request/confirm-step', data)
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public autoStep(data) {
    return this.http.post<any>(environment.apiUrl + '/backoffice/service-request/auto-step', data)
        .pipe(catchError(res => this.helper.catchError(res)));
  }

  public getServiceRequestPriorities() {
    return this.http.get<any>(environment.apiUrl + '/backoffice/service-request/priorities')
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public updateStatus(id, statusId) {
    return this.http.put(environment.apiUrl + '/backoffice/service-request/' + id + '/status',
      {status: statusId})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public updatePriority(id, priorityId) {
    return this.http.put(environment.apiUrl + '/backoffice/service-request/' + id + '/priority',
      {priority: priorityId})
      .pipe(catchError(res => this.helper.catchError(res)));
  }

  public fetchNotificationsCount() {
    this.http.get<any>(environment.apiUrl + '/backoffice/service-request/notifications-count')
      .pipe(catchError(res => this.helper.catchError(res))).subscribe((data) => {
      this.menuItems.setServiceBadge(data);
    });
  }
}
